import * as React from "react";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../schemaForm";
import { RowDefinition } from "../schemaform/layout-renderer";
import { ConfigData } from "../../config";
import { AddDeliveryDTO, AddRaceDTO, Driver, RaceType } from "../../api/model";
import NumberFormat from "react-number-format";
import { addDays, setMilliseconds } from "date-fns";
import { getApi } from "../../api/ApiProvider";
import googleMaps from "../../api/googleMaps";
import { ClientActions } from "../../store/client";

// components
import DeliverRouteSelector, { RouteData } from "./DeliveryRouteSelector";
import NewOrderForm from "./NewOrderForm";
import SearchBox from "../SearchBox";
import MoneyLabel from "../MoneyLabel";

// styles
import "../../assets/custom.css";

// utils
import { extractError } from "../../utils/errorHelper";
import { mockTheme, createWhattsappLink, bindActions } from "../../utils/utils";

// material
import {
  // FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Theme,
  WithStyles,
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Stepper from "@material-ui/core/Stepper";
import Typography from "@material-ui/core/Typography";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import CheckCircle from "@material-ui/icons/CheckCircle";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Switch from "@material-ui/core/Switch";
import { ComponentClass, connect } from "react-redux";

const styles = (theme: Theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginRight: theme.spacing.unit + 5,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },

  buttons: {
    textAlign: "right",
  },

  success: {
    textAlign: "center",
  },
  cardMedia: {
    width: 500,
    height: 300,
    minHeight: 400,
    margin: "auto",
  },
  textCoste: {
    textAlign: "right",
  },
  switchDefault: {
    float: "left",
    paddingTop: 10,
  },
  formControl: {
    margin: theme.spacing.unit * 2,
    minWidth: 120,
    textAlign: "right",
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

export interface RaceData {
  raceType: RaceType;
  observation?: string;
  withMoney: boolean;
  driver: number | null;
  amount?: number;
  dueDate?: string;
  user: { name: string; document: string; phone?: string; email?: string };
  origin: {
    street1: string;
    street2?: string;
    number?: number;
    observation?: string;
  };
  destiny: {
    street1: string;
    street2?: string;
    number?: number;
    observation?: string;
  };
  newClient: boolean;
  destinyObject: Location | undefined;
}

export type RaceAbmState = "edit" | "adding" | "added" | "error";

interface RaceAddProps extends WithStyles<keyof typeof classesType> {
  state: RaceAbmState;
  config: ConfigData;
  error?: any;
  companyId?: number;
  actions?: ClientActions;
  handleAdd(data: AddDeliveryDTO): void;
}

interface RaceAddState {
  selectedPaymentMethod?: number;
  payAmount?: number | any;
  paymentMethod?: string;
  invoice?: boolean;
  steps: string[];
  activeStep: number;
  data: RaceData;
  routeData?: RouteData;
  orderData?: any;
  schema: JSONSchema6 | null;
  searchingClient: boolean;
  clientSearch: any[];
  client: any;
  uiSchema: any;
}

const addRaceSchema: JSONSchema6 = {
  definitions: {
    user: {
      type: "object",
      required: ["name", "phone", "document"],
      properties: {
        name: { type: "string", title: "Nombre", minLength: 5 },
        document: { type: "string", title: "CI / RUC", minLength: 5 },
        phone: { type: "string", title: "Teléfono", minLength: 5 },
        email: { type: "string", title: "Correo" },
      },
    },
  },
  title: "",
  type: "object",
  required: ["user"],
  properties: {
    user: { title: "", $ref: "#/definitions/user" },
  },
};

const uiAddSchema = {
  "ui:layout": [{ user: { md: 12 } }] as RowDefinition[],

  user: {
    "ui:layout": [
      {
        document: { md: 6 },
        name: { md: 6 },
        email: { md: 6 },
        phone: { md: 6 },
      },
    ],
    document: {},
    name: {},
    email: {},
    phone: {},
  },
};

class AddDelivery extends React.Component<RaceAddProps, RaceAddState> {
  static getDefaultData(): RaceData {
    return {
      raceType: "DELIVERY",
      observation: "",
      withMoney: false,
      dueDate: addDays(setMilliseconds(new Date(), 0), 1).toISOString(),
      user: {
        name: "",
        document: "",
      },
      driver: 0,
      origin: { street1: "" },
      destiny: { street1: "" },
      newClient: true,
      destinyObject: undefined,
    };
  }

  private schemaNextButton: any;

  constructor(props: RaceAddProps) {
    super(props);

    const steps = [
      "Datos del Cliente",
      "Datos del Pedido",
      "Ruta de Entrega",
      "Resumen",
    ];
    const state: RaceAddState = {
      selectedPaymentMethod: 1,
      invoice: false,
      payAmount: "",
      paymentMethod: "EFECTIVO",
      steps,
      data: AddDelivery.getDefaultData(),
      activeStep: 0,
      schema: JSON.parse(JSON.stringify(addRaceSchema)),
      searchingClient: false,
      clientSearch: [],
      client: null,
      uiSchema: uiAddSchema,
    };
    if (props.config.races.predefinedFrom) {
      state.routeData = {
        origin: props.config.maps.startingLocation,
      };
    }

    this.state = state;

    this.handleNext = this.handleNext.bind(this);
    this.successFullSecondStep = this.successFullSecondStep.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.assignOkFormButton = this.assignOkFormButton.bind(this);
    this.handleNew = this.handleNew.bind(this);
    this.handleRouteSelection = this.handleRouteSelection.bind(this);
    this.retry = this.retry.bind(this);
    this.shareInfo = this.shareInfo.bind(this);
    this.handleSearchClient = this.handleSearchClient.bind(this);
    this.changeDefault = this.changeDefault.bind(this);
  }

  shareInfo() {
    if (!this.state.routeData || !this.state.routeData.destiny) {
      return;
    }
    const target = this.state.routeData.destiny;
    const map = `https://maps.google.com/?q=${target.lat},${target.lng}`;
    const link = createWhattsappLink(
      `Taxio - '${this.state.data.observation}'\nCliente: '${this.state.data.user.name}'\n\n${map}`
    );
    window.open(link, "_blank");
  }

  assignOkFormButton(formElement: any) {
    this.schemaNextButton = formElement;
  }

  handleNext() {
    const { activeStep } = this.state;
    if (
      activeStep === 1 &&
      !(this.state.orderData && this.state.orderData.length > 0)
    ) {
      return;
    }
    if (activeStep === 0) {
      this.schemaNextButton.click();

      return;
    }

    if (activeStep === 2) {
      if (!this.state.routeData || !this.state.routeData.fullData) {
        // the route is wrong
        return;
      } else {
        let locationId;

        if (this.state.routeData && this.state.routeData.clientDocument) {
          if (this.state.routeData.selectedClientLocationId) {
            locationId = this.state.routeData.selectedClientLocationId;
          }
        }

        this.setState({
          data: {
            ...this.state.data,
            origin: {
              ...this.state.data.origin,
              street1: this.state.routeData.originStreet || "",
              branch: this.state.routeData.selectedBranch,
            },
            destiny: {
              ...this.state.data.destiny,
              street1: this.state.routeData.destinyStreet || "",
              id: locationId,
            },
          },
        });
      }
    }

    if (
      activeStep === 3 &&
      this.state.routeData &&
      this.state.routeData.origin &&
      this.state.routeData.destiny
    ) {
      const total = this.calcTotal(this.state.orderData);
      console.log(this.state.routeData.destinyObject);
      this.props.handleAdd({
        opportunity: {
          type: this.state.data.raceType,
          observation: this.state.data.observation,
          clientDocument: this.state.data.user.document,
          clientName: this.state.data.user.name,
          clientEmail: this.state.data.user.email,
          clientPhone: this.state.data.user.phone,
          origin: {
            ...this.state.data.origin,
            lat: this.state.routeData.origin.lat,
            lng: this.state.routeData.origin.lng,
          },
          destiny: {
            ...this.state.data.destiny,
            ...this.state.routeData.destinyObject,
            lat: this.state.routeData.destiny.lat,
            lng: this.state.routeData.destiny.lng,
          },
          dueDate: +new Date(this.state.data.dueDate || 0),
          amount: this.state.routeData.amount,
          driver: this.state.routeData.driver
            ? this.state.routeData.driver
            : null,
          branch: this.state.routeData.selectedBranch
            ? this.state.routeData.selectedBranch.id
            : undefined,
        },
        amount: this.state.payAmount,
        total: total + this.state.routeData.amount,
        paymentMethod: this.state.paymentMethod,
        priceDelivery: this.state.routeData.amount,
        invoice: this.state.invoice,
        items: this.state.orderData,
      });
    }

    this.setState({
      activeStep: activeStep + 1,
    });
  }

  successFullSecondStep(form: any) {
    this.setState({
      activeStep: this.state.activeStep + 1,
      data: form.formData,
    });
  }

  handleBack() {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  }

  retry() {
    this.setState({
      activeStep: 0,
    });
  }

  handleNew() {
    this.setState({
      activeStep: 0,
      data: AddDelivery.getDefaultData(),
      routeData: undefined,
    });
  }

  handleRouteSelection(data: RouteData) {
    console.log(data);
    this.setState({
      routeData: data,
    });
  }

  handleSearchClient(searchValue: string) {
    if (searchValue.length > 0) {
      this.setState({ searchingClient: true });
      getApi()
        .client()
        .filter(searchValue)
        .then(
          (data: any) => {
            console.log(data);
            this.setState({ clientSearch: data, searchingClient: false });
            if (data.length === 0) {
              console.log("RESET - EMPTY RESULTS");
              this.setClient(null);
            }
          },
          (error: any) => {
            this.setState({ searchingClient: false });
            console.log("error busqueda cliente -->>", error);
          }
        );
    }
  }

  calcTotal = (items: any) => {
    let total = 0;
    items.map((item: any) => {
      total += item.quantity * item.price;
    });
    return total;
  };

  handleChangePaymentMethod(e: any) {
    this.setState({
      ...this.state,
      selectedPaymentMethod: e,
      paymentMethod: e === 1 ? "EFECTIVO" : "TARJETA",
    });
  }

  setClient(client: any) {
    if (client === null) {
      console.log("here");
      this.setState({
        data: {
          ...this.state.data,
          user: {
            ...this.state.data.user,
            document: "",
            name: "",
            phone: "",
            email: "",
          },
          newClient: true,
        },
        uiSchema: {
          ...uiAddSchema,
          user: {
            "ui:layout": [
              {
                document: { md: 6 },
                name: { md: 6 },
                email: { md: 6 },
                phone: { md: 6 },
              },
            ],
            document: { "ui:autofocus": true },
            name: {},
            email: {},
            phone: {},
          },
        },
      });

      return;
    }
    this.setState({
      data: {
        ...this.state.data,
        user: {
          ...this.state.data.user,
          document: client.document,
          name: client.user.name,
          phone: client.phone,
          email: client.user.email,
        },
        newClient: false,
      },
      client: client,
      uiSchema: {
        ...uiAddSchema,
        user: {
          "ui:layout": [
            {
              document: { md: 6 },
              name: { md: 6 },
              email: { md: 6 },
              phone: { md: 6 },
            },
          ],
          document: { "ui:autofocus": true, "ui:readonly": true },
          name: { "ui:readonly": true },
          email: { "ui:readonly": true },
          phone: { "ui:readonly": false },
        },
      },
    });
  }

  renderSelectClient() {
    if (this.state.clientSearch.length > 1) {
      return (
        <>
          <InputLabel htmlFor="cliente">Seleccione un cliente</InputLabel>
          <Select
            style={{ width: "100%" }}
            onChange={(event) => {
              this.setClient(event.target.value);
              this.setState({ clientSearch: [] });
            }}
            placeholder="Selecione un cliente de la lista"
            inputProps={{
              name: "cliente",
              id: "cliente",
            }}
          >
            {this.state.clientSearch.map((client: any, index) => (
              <MenuItem key={index} value={client}>
                {client.document} - {client.user.name}
              </MenuItem>
            ))}
          </Select>
          <br />
          <br />
        </>
      );
    }

    if (this.state.clientSearch.length === 1) {
      this.setClient(this.state.clientSearch[0]);
      this.setState({ clientSearch: [] });
      return null;
    }

    return null;
  }

  changeDefault(location: any) {
    this.props.actions.updateLocation(location);
  }

  renderStep(step: number) {
    // Render Order : Datos cliente, datos pedido, ruta entrega, resumen.
    switch (step) {
      case 0:
        // CLIENTE
        if (!this.state.schema) {
          return <CircularProgress size={50} style={{ marginBottom: 20 }} />;
        } else {
          return (
            <>
              <div style={{ marginRight: 10 }}>
                <SearchBox
                  hasFilter={false}
                  placeHolder="Ingrese CI y presione ENTER"
                  doSearch={this.handleSearchClient}
                />
                {this.state.searchingClient ? (
                  <CircularProgress size={50} style={{ marginBottom: 20 }} />
                ) : (
                  <br />
                )}
                {this.state.clientSearch.length > 0 ? (
                  this.renderSelectClient()
                ) : (
                  <br />
                )}
              </div>
              <div style={{ margin: 25 }}>
                <EnhancedSchemaForm
                  schema={this.state.schema}
                  uiSchema={this.state.uiSchema}
                  formData={this.state.data}
                  onSubmit={this.successFullSecondStep}
                >
                  <div>
                    <Button
                      style={{ display: "none" }}
                      variant="contained"
                      color="primary"
                      type="submit"
                      buttonRef={this.assignOkFormButton}
                    >
                      Aceptar
                    </Button>
                  </div>
                </EnhancedSchemaForm>
              </div>

              <div style={{ textAlign: "center" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  type="button"
                  onClick={() => this.setClient(null)}
                >
                  Limpiar
                </Button>
              </div>

              <hr />
            </>
          );
        }
      case 1:
        // PEDIDO
        return (
          <NewOrderForm
            config={this.props.config}
            companyId={this.props.companyId}
            previousData={this.state.orderData}
            updateOrder={(orderData: any) => {
              this.setState({ orderData: orderData });
            }}
          />
        );
      case 2:
        // RUTA
        return (
          <DeliverRouteSelector
            data={this.state.routeData}
            companyId={this.props.companyId}
            raceData={this.state.data}
            config={this.props.config}
            onNewData={this.handleRouteSelection}
            defaultChange={this.changeDefault}
          />
        );
      case 3:
        // RESUMEN
        const data = this.state.data;
        const route = this.state.routeData;
        if (!data || !route) {
          return <div />;
        }
        let imageUrl: string | null = null;
        if (route.route) {
          imageUrl = googleMaps.buildStaticImage(
            this.props.config.maps.key,
            route.route.overview_polyline
          );
        }
        console.log(route.route);
        let total = 0;
        const paymentMethods = [
          { id: 1, name: "EFECTIVO" },
          { id: 2, name: "TARJETA" },
        ];

        return (
          <Card style={{ marginBottom: 40, padding: 10 }}>
            <Grid container>
              <Grid item md={6}>
                <CardContent>
                  <Typography gutterBottom variant="headline" component="h2">
                    {data.raceType}
                  </Typography>
                  <hr />

                  <Typography component="p">{data.observation}</Typography>
                  <br />

                  <Typography variant="title">Cliente</Typography>
                  <br />
                  <div style={{ paddingLeft: 10 }}>
                    <Typography component="p">
                      Nombre: <b>{data.user.name}</b>
                    </Typography>
                    <Typography component="p">
                      Documento: <b>{data.user.document}</b>
                    </Typography>
                    <Typography component="p">
                      Telefono: <b>{data.user.phone}</b>
                    </Typography>
                  </div>
                  <hr />

                  <Typography variant="title">Ruta</Typography>
                  <br />
                  <div style={{ paddingLeft: 10 }}>
                    <Typography>
                      El viaje es de:{" "}
                      <NumberFormat
                        value={(route.distance || 0) / 1000}
                        suffix={" Km."}
                        displayType={"text"}
                        decimalScale={1}
                      />
                    </Typography>
                    {route.selectedBranch && (
                      <Typography>
                        Desde: <b>Sucursal {route.selectedBranch.name}</b>
                      </Typography>
                    )}
                    {route.destinyObject && (
                      <Typography>
                        Hasta:{" "}
                        <b>
                          {route.destinyObject.street1 +
                            (route.destinyObject.number
                              ? ` #${route.destinyObject.number}`
                              : "") +
                            (route.destinyObject.street2
                              ? `, ${route.destinyObject.street2}`
                              : "")}
                        </b>
                      </Typography>
                    )}
                  </div>
                  <hr />
                </CardContent>
              </Grid>
              <Grid item md={6}>
                {imageUrl && (
                  <CardMedia
                    className={this.props.classes.cardMedia}
                    image={imageUrl}
                    title="Imagen de la ruta"
                  />
                )}
              </Grid>
            </Grid>
            <Grid item md={12}>
              <CardContent>
                <Typography variant="title">Pedido</Typography>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Producto</TableCell>
                      {/* <TableCell>Observación</TableCell> */}
                      <TableCell numeric>Cantidad</TableCell>
                      <TableCell numeric>Precio</TableCell>
                      <TableCell numeric>Sub-Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.orderData.map((row: any, index: number) => {
                      const subtotal = row.price * row.quantity;
                      total = total + subtotal;
                      return (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {row.name}
                          </TableCell>
                          {/* <TableCell component="th" scope="row">
                            {row.observation}
                           </TableCell> */}
                          <TableCell numeric>{row.quantity}</TableCell>
                          <TableCell numeric>{row.price}</TableCell>
                          <TableCell numeric>{subtotal}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <div className={this.props.classes.switchDefault}>
                  <Switch
                    checked={this.state.invoice}
                    onChange={(e) =>
                      this.setState({ invoice: e.target.checked })
                    }
                    // disabled
                  />{" "}
                  &nbsp;
                  <span>Preparar factura</span>
                  <br />
                  <br />
                  <span>Forma de pago: </span>
                  &nbsp;
                  <Select
                    value={this.state.selectedPaymentMethod}
                    onChange={(e) =>
                      this.handleChangePaymentMethod(e.target.value)
                    }
                  >
                    {paymentMethods.map((p, index) => (
                      <MenuItem key={index} value={p.id}>
                        {p.name}{" "}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className={this.props.classes.textCoste}>
                  <br />
                  {route.amount && (
                    <Typography variant="subheading">
                      Costo de envío <MoneyLabel amount={route.amount} />
                    </Typography>
                  )}

                  <Typography variant="title">
                    Total:{" "}
                    <MoneyLabel
                      amount={total + (route.amount ? route.amount : 0)}
                    />
                  </Typography>

                  <br />

                  {this.state.paymentMethod === "EFECTIVO" && (
                    <TextField
                      type="number"
                      label="Efectivo del cliente"
                      placeholder="Monto"
                      inputProps={{ style: { textAlign: "end" } }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{
                        width: "12%",
                      }}
                      value={this.state.payAmount}
                      onChange={(e) =>
                        this.setState({
                          ...this.state,
                          payAmount: Number(e.target.value),
                        })
                      }
                      margin="normal"
                    ></TextField>
                  )}

                  {this.state.payAmount !== 0 &&
                    this.state.payAmount !== "" &&
                    this.state.paymentMethod === "EFECTIVO" && (
                      <Typography variant="subheading">
                        Vuelto:{" "}
                        <MoneyLabel
                          amount={
                            this.state.payAmount -
                            (total + (route.amount ? route.amount : 0))
                          }
                        />
                      </Typography>
                    )}
                </div>
              </CardContent>
            </Grid>
          </Card>
        );
    }

    if (this.props.state === "added") {
      return (
        <div className={this.props.classes.success}>
          <br />
          <CheckCircle color="primary" style={{ fontSize: 80 }} />
          <br />
          <br />
          <Typography variant="title">Carrera creada correctamente</Typography>
          <br />
          <br />
          <Button variant="contained" color="primary" onClick={this.handleNew}>
            Crear otra
          </Button>
          <br />
          <br />
          <br />
          <Button
            variant="contained"
            color="secondary"
            onClick={this.shareInfo}
          >
            Enviar datos al chofer
          </Button>
        </div>
      );
    }

    if (this.props.state === "error" && this.props.error) {
      const err = extractError(this.props.error);
      return (
        <div className={this.props.classes.success}>
          <br />
          <RemoveCircle color="error" style={{ fontSize: 80 }} />
          <br />
          <br />
          <Typography variant="title">
            Error {err.type}
            {err.properties.map((prop) => {
              return (
                <div key={prop.property}>
                  {prop.property}: {prop.message}
                </div>
              );
            })}
          </Typography>
          <br />
          <Button variant="contained" color="primary" onClick={this.retry}>
            Reintentar
          </Button>
        </div>
      );
    }

    return (
      <div className={this.props.classes.success}>
        <br />
        <CircularProgress color="primary" thickness={7} />
        <br />
        <br />
        <Typography variant="title">Procesando</Typography>
        <br />
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    const { activeStep, steps } = this.state;

    return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label, index) => {
            return (
              <Step key={label} completed={index < activeStep}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {this.renderStep(activeStep)}
        <div className={classes.buttons}>
          {activeStep === steps.length ? (
            <div></div>
          ) : (
            <div>
              <div>
                <Button
                  disabled={activeStep === 0}
                  onClick={this.handleBack}
                  className={classes.button}
                >
                  {" "}
                  Atras{" "}
                </Button>
                <Button
                  variant="contained"
                  disabled={
                    (this.state.payAmount === 0 ||
                      this.state.payAmount === "") &&
                    this.state.paymentMethod === "EFECTIVO" &&
                    activeStep === steps.length - 1
                  }
                  color="primary"
                  onClick={this.handleNext}
                  className={classes.button}
                >
                  {" "}
                  {activeStep === steps.length - 1 ? "Crear" : "Siguiente"}{" "}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: "", ownProps: RaceAddProps) => ({});

const styled = withStyles(styles as any)(AddDelivery);
const connected = connect(mapStateToProps, bindActions(ClientActions))(styled);

export default connected as ComponentClass<Partial<RaceAddProps>>;



// WEBPACK FOOTER //
// ./src/components/delivery/AddDelivery.tsx